import type { PublicApiKey } from '#packages/apilib';
import type { createEditorUIApi } from './editorUIApi';

export const EditorUIApiKey: PublicApiKey<typeof createEditorUIApi> = {
  name: 'EditorUIApi',
  public: true,
};
